import { Link } from "react-router-dom";
import logo from "../../assets/kailospay/logo-blue.png";
export default function JulyFooter() {
  return <footer className="jp-footer"><div className="jp-wrap">
    <div className="jp-footer-top"><Link to="/" className="jp-brand" aria-label="주류페이 홈"><img src={logo} alt="주류페이" /></Link><nav aria-label="하단 메뉴"><Link to="/support">고객센터</Link><Link to="/terms">이용약관</Link><Link to="/privacy">개인정보처리방침</Link></nav></div>
    <p>주류페이 · 대표 강대부 · 사업자등록번호 518-88-03068 · 통신판매업신고 2024-전북익산-0474<br />전북특별자치도 익산시 동천7길 72 카이로스빌딩 3층<br /><a href="tel:18997179">1899-7179</a> (평일 09:00~17:30) · <a href="mailto:julyupay@gmail.com">julyupay@gmail.com</a></p>
    <small>© {new Date().getFullYear()} JULYUPAY. All rights reserved.</small>
  </div></footer>;
}
